/**
 * Array filter function that return only unique item in a given array
 * @param {*} value the value of the current enumerated item
 * @param {*} index the current enumerated index
 * @param {*} self the array being filtered
 * @returns
 */
function onlyUnique(value, index, self) {
   return self.indexOf(value) === index
}

module.exports = { onlyUnique }
